export default [
  "all-employees",
  "active-employees",
  "not-active-employees",
];
